<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="body_introduction" id="calibre_pb_60">This is my go-to breakfast Monday through Friday, and I never get tired of it! It’s nutrient dense, loaded with texture, and this version is 100% dairy free.</p>
<p class="body_instruction-next-para1"><span class="bold1">To cook the quinoa</span>, bring 2 cups of water to a boil. <span class="charoverride5">Before adding the quinoa, rinse it under water to remove any debris,</span> then boil for 13 minutes. Drain very well and add to a serving bowl along with the coconut cream and mix well. Top with granola, yogurt, fruit, <span>and</span><span> </span><span>enjoy!</span></p>
<p class="shopping-tip-centered-2col"><img alt="" class="calibre3" src="OEBPS/image/image-337.png"/></p>
<p class="shopping-tip-centered-2col">We eat grain-free and paleo <span class="shopping-tip-bold-red1">granola</span> at home, meaning no refined sugars or oats. My absolute favorite brand is Purely Elizabeth, followed by Autumn’s Gold at Costco. They have a great price. Search “FlavCity granola” on YouTube to learn more about shopping fo<span>r</span><span> </span><span>granola.</span></p>
<p class="shopping-tip-centered-2col"><img alt="" class="calibre3" src="OEBPS/image/image-340.png"/></p>
<p class="shopping-tip-centered-2col"><span class="shopping-tip-bold-red1">Yogurt</span> can be a minefield! I highly suggest searching “FlavCity Yogurt” on YouTube to learn more. If you want the best-quality yogurt, 100% grass-fed and full fat is the way to go. Stonyfield 100% grass-fed and Greek style is one of the best, and my favorite plant-based yogurt is plain Greek-style Kite Hill and vani<span>lla</span><span> </span><span>Lavva.</span></p>
<p class="macro_macro-table-heading"><span class="bold2">Macros per serving (makes 1):</span></p>
<table class="table-style" id="table002">
<colgroup class="calibre5">
<col class="calibre6"/>
<col class="calibre6"/>
<col class="calibre6"/>
<col class="calibre6"/>
<col class="calibre6"/>
<col class="calibre6"/>
</colgroup>
<tbody class="calibre7">
<tr class="table-style1">
<td class="table-style3">
<p class="macro_macro-table">CALORIES</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">NET CARBS</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">TOTAL CARBS</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">FAT</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">PROTEIN</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">FIBER</p>
</td>
</tr>
<tr class="table-style1">
<td class="table-style3">
<p class="macro_macro-table">460cal</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">48.9g</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">55.9g</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">21.9g</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">11.7g</p>
</td>
<td class="table-style3">
<p class="macro_macro-table">7.1g</p>
</td>
</tr>
</tbody>
</table>
<div class="calibre1" id="calibre_pb_61"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_037.vue?10ade8a3